import Store from "App/Store.js";

export default features => Store.dispatch({type: "features", features});
